/**
 * File: src/components/newsletter-form.js
 * Mô tả: Component biểu mẫu đăng ký nhận tin tức studio SNT Games với thông báo phản hồi, hỗ trợ i18n.
 * Liên quan: src/i18n/i18n-service.js, src/services/newsletter-service.js
 */

import { siteConfig } from '../data/site-config.js';
import { createElement } from '../utils/dom.js';
import { subscribeNewsletter } from '../services/newsletter-service.js';
import { getLanguage, t, onLanguageChange } from '../i18n/i18n-service.js';

export const renderNewsletterForm = () => {
  const section = createElement('section', {
    className: 'section newsletter-section',
    attributes: { id: 'newsletter' },
  });

  const renderContent = () => {
    const endpoint = import.meta.env?.VITE_NEWSLETTER_ENDPOINT;
    if (!endpoint || endpoint === 'https://api.sntgames.com/newsletter') {
      section.innerHTML = `<div class="container"><div class="newsletter-card">
        <h2 class="newsletter-title">${getLanguage() === 'en' ? 'Contact SNT Games' : 'Liên hệ SNT Games'}</h2>
        <p>${getLanguage() === 'en' ? 'Need help with a game? Email our team.' : 'Bạn cần hỗ trợ về game? Gửi email cho đội ngũ.'}</p>
        <a class="company-email" href="mailto:${siteConfig.contact.email}">${siteConfig.contact.email}</a>
      </div></div>`;
      return;
    }
    section.innerHTML = `
      <div class="container">
        <div class="newsletter-card">
          <h2 class="newsletter-title">${t('newsletter.title')}</h2>
          <p class="newsletter-subtitle">${t('newsletter.subtitle')}</p>
          <form class="newsletter-form" id="newsletter-form-element">
            <input
              type="email"
              class="newsletter-input"
              placeholder="${t('newsletter.placeholder')}"
              required
              aria-label="Email Address" autocomplete="email"
            />
            <button type="submit" class="btn btn-primary newsletter-btn">
              <span>${t('newsletter.subscribe')}</span>
            </button>
          </form>
          <div class="newsletter-feedback" id="newsletter-feedback" role="status" aria-live="polite" style="display: none; margin-top: 1rem; font-size: 0.9rem;"></div>
        </div>
      </div>
    `;

    const form = section.querySelector('#newsletter-form-element');
    const feedback = section.querySelector('#newsletter-feedback');

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('.newsletter-input');
        const email = input?.value?.trim();
        if (!email) return;

        const button = form.querySelector('button');
        button.disabled = true;
        const result = await subscribeNewsletter(email);
        button.disabled = false;
        if (feedback) {
          feedback.style.display = 'block';
          feedback.textContent = result.success ? t('newsletter.success') : result.message;
          feedback.style.color = result.success ? 'var(--color-accent)' : '#ef4444';
          if (result.success && input) input.value = '';
        }
      });
    }
  };

  renderContent();
  onLanguageChange(() => renderContent());

  return section;
};
